// src/components/PageSkeleton.js
// 统一页面骨架：面包屑 + 页头 + 筛选/操作栏 + 内容区
// 所有模块骨架页（ModulePage）与单站「系统管理」面板共用此外壳，保证风格统一。
import React from 'react';
import { Breadcrumb, Select, DatePicker, Input, Button, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import PageHead from './PageHead';

const { RangePicker } = DatePicker;

// 依据描述渲染单个筛选控件（受控：value + onChange）
const FilterField = ({ f, value, onChange }) => {
  switch (f.type) {
    case 'select':
      return (
        <Select
          value={value ?? undefined}
          onChange={onChange}
          placeholder={f.placeholder || `请选择${f.label || ''}`}
          options={f.options}
          style={{ width: f.width || 180 }}
          allowClear
        />
      );
    case 'daterange':
      return (
        <RangePicker
          value={value ?? null}
          onChange={onChange}
          placeholder={['开始日期', '结束日期']}
        />
      );
    case 'month':
      return <DatePicker picker="month" value={value ?? null} onChange={onChange} placeholder="选择月份" />;
    case 'search':
      return (
        <Input
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={f.placeholder || '请输入关键词'}
          prefix={<SearchOutlined />}
          style={{ width: f.width || 220 }}
          allowClear
        />
      );
    default:
      return null;
  }
};

const PageSkeleton = ({
  title, desc, crumb, filters, actions, onAction, extra, children,
  filterValues = {}, onFilterChange, onTitleClick,
}) => {
  const crumbs = (crumb || []).filter(Boolean);
  const hasBar = (filters && filters.length) || (actions && actions.length);

  return (
    <div className="page-skeleton">
      {crumbs.length > 1 ? (
        <Breadcrumb
          className="page-crumb"
          separator="/"
          items={crumbs.map((t) => ({ title: t }))}
        />
      ) : null}

      <PageHead title={title} desc={desc} extra={extra} onTitleClick={onTitleClick} />

      {hasBar ? (
        <div className="filter-bar">
          <div className="filter-bar-fields">
            {(filters || []).map((f, i) => (
              <div className="filter-item" key={f.key || i}>
                {f.label ? <span className="filter-label">{f.label}</span> : null}
                <FilterField
                  f={f}
                  value={filterValues[f.key]}
                  onChange={(v) => onFilterChange && onFilterChange(f.key, v, f)}
                />
              </div>
            ))}
          </div>
          <div className="filter-bar-actions">
            <Space wrap>
              {(actions || []).map((a, i) => (
                <Button
                  key={a.key || i}
                  type={a.primary ? 'primary' : 'default'}
                  icon={a.icon}
                  onClick={() => onAction && onAction(a)}
                >
                  {a.label}
                </Button>
              ))}
            </Space>
          </div>
        </div>
      ) : null}

      <div className="page-skeleton-body">{children}</div>
    </div>
  );
};

export default PageSkeleton;